import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

export type ShareContainingRangeRequest = {
  partnerId: string;
  shareFrom: number;
  shareTo: number;
};

export type ShareContainingRangeMatch = {
  partnerId: string;
  shareFrom: number;
  shareTo: number;
  share: {
    _id: string;
    from: number;
    to: number;
    partner: string;
  } | null;
};

type ResolveSharesContainingRangesProps = {
  societyId: string;
  ranges: ShareContainingRangeRequest[];
};

export const resolveSharesContainingRanges = async ({
  societyId,
  ranges,
}: ResolveSharesContainingRangesProps): Promise<ShareContainingRangeMatch[]> => {
  if (!societyId || !ranges?.length) {
    return [];
  }

  const { data } = await axiosV2.post('/shares/containing-ranges', {
    societyId,
    ranges,
  });

  const decodedData = (await decryptResponse(
    data
  )) as ShareContainingRangeMatch[];

  return Array.isArray(decodedData) ? decodedData : [];
};
